import React from "react";
import { Outlet } from "react-router-dom";
import toast from "react-hot-toast";
import useAuth from "../hooks/useAuth";
import DialogflowMessenger from "../components/DialogueFlowMessenger";
import paymentLayout from "./paymentLayout";
import defaultLayout from "./defaultLayout";
import { useLocation } from "react-router-dom";


export default function Layout() {
  const { token, logout, loading } = useAuth();
  const location = useLocation();
  const isPlansPage = location.pathname.startsWith("/dashboard");

  const Layout = isPlansPage ? defaultLayout : paymentLayout ;

  return (
    <main className="">
        <Layout/>
    </main>
  );
}
